import React from 'react';
import './BlueFireEffect.scss';

const parts = 50;

export const BlueFireEffect = () => {
  return (
    <div className="blue-fire">
      {Array.from({ length: parts }).map((_, index) => (
        <div key={index} className="blue-particle"></div>
      ))}
    </div>
  );
};
